<div class="flex items-start gap-2.5 w-full">
    <!-- Error icon, mirrors the ✓ in success toasts -->
    <span class="p-toast-message-icon shrink-0" aria-hidden="true">
        <i class="fa-solid fa-circle-xmark text-xl mt-0.5"></i>
    </span>

    <div class="flex flex-col gap-1.5 flex-1 min-w-0">
        <div class="p-toast-summary font-bold text-base leading-snug">
            {{ message().data.message }} -
            <a class="text-primary font-bold cursor-pointer hover:underline"
               [routerLink]="['t', tenantExternalIdComputed(), 'system-configuration', 'integrations', 'processing-log']"
               target="_blank" rel="noopener noreferrer">
                View
            </a>
        </div>

        <span class="text-sm text-white">
            {{ message().data.content?.primaryText }}
        </span>

        <span class="text-xs text-white opacity-80 font-mono tracking-wide">
            {{ message().data.content?.secondaryText }}
        </span>
    </div>
</div>